module.exports = __webpack_public_path__ + "static/media/a4_briefpapier.6d3c5e0b.jpg";